



































// Vue
import { Component, Prop, Vue } from 'vue-property-decorator';

// Components
import Avatar from '@/shared/components/Avatar.component.vue';
import Tooltip, {
  TooltipColor,
} from '@/shared/components/Tooltip.component.vue';

// Exports
export { TooltipColor };

export interface TextAndStyle {
  text: string;
  size: string;
}

export enum ItemThumbPrefeginedStyle {
  Standard = 'item-thumb--standard',
  Responsive = 'item-thumb--responsive',
  Bigger = 'item-thumb--bigger',
  Middle = 'item-thumb--middle',
}
export enum TittleFontFamily {
  Default = 'item-thumb__title__primary',
  Tertiary = 'item-thumb__title__tertiary',
}
export enum SubtitleFontFamily {
  Default = 'item-thumb__title__primary',
  Ttruns = 'item-thumb__subtitle__ttruns',
}

@Component({
  components: {
    Avatar,
    Tooltip,
  },
})
export default class ItemThumb extends Vue {
  @Prop({ default: '' }) private imageUrl!: string;
  @Prop() private title!: TextAndStyle;
  @Prop({ default: TittleFontFamily.Default })
  private titleFontFamily!: TittleFontFamily;
  @Prop({ default: SubtitleFontFamily.Default })
  private subtitleFontFamily!: SubtitleFontFamily;

  @Prop({
    default() {
      return { text: '', size: '' } as TextAndStyle;
    },
  })
  private subtitle!: TextAndStyle;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: false }) private isClickable!: boolean;
  @Prop({ default: '' }) private tooltipText!: string;
  @Prop({ default: TooltipColor.Primary }) private itemTooltipColor!: string;
  @Prop({ default: ItemThumbPrefeginedStyle.Standard })
  private itemThumbPredefinedStyle!: ItemThumbPrefeginedStyle;

  private tooltipColor = TooltipColor;
  private titleClassObject = {
    'item-thumb--xl': this.title.size === 'Big',
    'item-thumb--xxl': !this.title.size,
  };

  private subtitleClassObject = {
    'fs-md': this.subtitle.size === 'Big',
    'fs-xs': !this.subtitle.size,
  };

  private disabledClassObject = {
    'item-thumb--disabled': this.disabled,
  };

  get isDisabled() {
    return this.tooltipText === ' ';
  }

  private itemTumbClicked() {
    this.$emit('item-thumb-clicked');
  }
}
